import { useRef, useState, useEffect } from "react";

const FIXED_MARGIN = 10;
const LEFT_OFFSET = 65; // ancho del el menu
const TOP_OFFSET = 65; // altura header

const useBotDraggable = (open) => {

    const [bounds, setBounds] = useState(undefined);
    const dragRef = useRef(null);

    useEffect(() => {
        if (!open) return;

        const updateBounds = () => {
            const el = dragRef.current;
            if (!el) return;
            const { offsetWidth: w, offsetHeight: h } = el;
            setBounds({
                left: Math.min(0, -(window.innerWidth - FIXED_MARGIN - w - LEFT_OFFSET - 5)),
                top: Math.min(0, -(window.innerHeight - FIXED_MARGIN - h - TOP_OFFSET - 5)),
                right: FIXED_MARGIN - 5,
                bottom: FIXED_MARGIN - 5,
            });
        };

        updateBounds();
        window.addEventListener("resize", updateBounds);
        return () => window.removeEventListener("resize", updateBounds);
    }, [open]);

    return {
        dragRef,
        bounds,
    }
};

export default useBotDraggable;